module.exports = __webpack_public_path__ + "img/advantages_clock.83612d7.svg";